<header class="header-main" [class.sticky]="isSticky">
  <div class="container-fluid">
    <div class="container">
      <nav class="navbar navbar-dark navbar-expand-lg py-0">
        
        <!-- Brand / Logo -->
        <a routerLink="/" class="navbar-brand" (click)="closeMenu()">
          <h2 class="text-white fw-bold d-block">Job<span class="color-secondary">Son</span></h2>
        </a>

        <!-- Navbar Toggler for Mobile -->
        <button 
          type="button" 
          class="navbar-toggler me-0" 
          (click)="toggleMenu()"
          [attr.aria-expanded]="!isMenuCollapsed" 
          aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Navbar Menu -->
        <div 
          class="collapse navbar-collapse bg-transparent mobile-scroll-menu" 
          [class.show]="!isMenuCollapsed" 
          id="navbarCollapse">
          
          <div class="navbar-nav ms-auto mx-xl-auto p-0">
            <a 
              routerLink="/" 
              routerLinkActive="active color-secondary" 
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-item nav-link"
              (click)="closeMenu()">Home</a>
            
            <a 
              routerLink="/about-us" 
              routerLinkActive="active color-secondary" 
              class="nav-item nav-link"
              (click)="closeMenu()">About</a>
            
            <a 
              routerLink="/services" 
              routerLinkActive="active color-secondary" 
              class="nav-item nav-link"
              (click)="closeMenu()">Services</a>
            
            <a 
              routerLink="/portfolio" 
              routerLinkActive="active color-secondary" 
              class="nav-item nav-link"
              (click)="closeMenu()">Portfolio</a>

            <!-- Pages Dropdown -->
            <div class="nav-item dropdown" [class.show]="isDropdownOpen">
              <a 
                href="#" 
                class="nav-link dropdown-toggle" 
                (click)="toggleDropdown($event)"
                [attr.aria-expanded]="isDropdownOpen">Pages</a>
              
              <div class="dropdown-menu rounded" [class.show]="isDropdownOpen">
                <a routerLink="/blog-grid" routerLinkActive="active" class="dropdown-item" (click)="closeMenu()">Our Blog</a>
                <a routerLink="/our-team" routerLinkActive="active" class="dropdown-item" (click)="closeMenu()">Our Team</a>
                <a routerLink="/testimonials" routerLinkActive="active" class="dropdown-item" (click)="closeMenu()">Testimonial</a>
                <a routerLink="/404" routerLinkActive="active" class="dropdown-item" (click)="closeMenu()">404 Page</a>
              </div>
            </div>

            <a 
              routerLink="/contact" 
              routerLinkActive="active color-secondary" 
              class="nav-item nav-link"
              (click)="closeMenu()">Contact</a>
          </div>
        </div>

        <!-- Phone Section -->
        <div class="d-none d-xl-flex flex-shrink-0">
          <div id="phone-tada" class="d-flex align-items-center justify-content-center me-4">
            <a href="tel:+01234567890" class="position-relative animated tada infinite">
              <i class="fa fa-phone-alt text-white fa-2x"></i>
              <div class="position-absolute" style="top: -7px; left: 20px;">
                <span><i class="fa fa-comment-dots color-secondary"></i></span>
              </div>
            </a>
          </div>
          <div class="d-flex flex-column pe-4">
            <span class="text-white-50">Have any questions?</span>
            <span class="color-secondary">Call: + 0123 456 7890</span>
          </div>
        </div>

      </nav>
    </div>
  </div>
</header>